import { Button, IconButton, Typography } from "@ecologi/react-components/src";
import styled from "@emotion/styled";
import { ReactNode } from "react";
import { CloseIcon, TickIcon, PencilIcon, PlusIcon } from "./icon.styles";

const EditorContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

const StyledIconButton = styled(IconButton)`
  margin-top: 12px;
`;

export type ProductInlineFieldEditorProps = {
  label: string;
  value: string;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  renderEditor: ReactNode;
  addButtonText: string;
  testIdPrefix: string;
};

export const ProductInlineFieldEditor = ({
  label,
  value,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  renderEditor,
  addButtonText,
  testIdPrefix,
}: ProductInlineFieldEditorProps) => {
  if (isEditing) {
    return (
      <EditorContainer>
        {renderEditor}
        <StyledIconButton
          ariaLabel={`Save ${label.toLowerCase()}`}
          icon={TickIcon}
          data-testid={`save-${testIdPrefix}`}
          onClick={onSave}
        />
        <StyledIconButton
          ariaLabel={`Close ${label.toLowerCase()} editor`}
          icon={CloseIcon}
          onClick={onCancel}
        />
      </EditorContainer>
    );
  }

  return (
    <EditorContainer>
      {value ? (
        <>
          <Typography use="body2" as="h4" data-testid={`${testIdPrefix}-text`}>
            <strong>{label}: </strong>
            {value}
          </Typography>
          <IconButton
            ariaLabel={`Edit ${label.toLowerCase()}`}
            data-testid={`edit-${testIdPrefix}`}
            icon={PencilIcon}
            onClick={onEdit}
          />
        </>
      ) : (
        <Button
          text={addButtonText}
          data-testid={`add-${testIdPrefix}`}
          invert
          small
          icon={PlusIcon}
          onClick={onEdit}
        />
      )}
    </EditorContainer>
  );
};
